var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSubject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13 16h-10a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2zm-10-8h18a1 1 0 0 0 0-2h-18a1 1 0 0 0 0 2zm18 3h-18a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubject);
export default __webpack_public_path__ + "static/media/icon-subject.19d4704ddd5bf0a3df39fa8dd3be77fb.svg";
export { ForwardRef as ReactComponent };